// src/app/pages/definition/CashRegister/CashRegisterModel.ts
import * as Yup from 'yup'




export interface ICashRegisterModel {
  id?: number
  createdAt?: Date | string
  updatedAt?: Date | string

  // Sol blok
  cariAra?: string                 // Cari Ara
  name: string                     // Ad
  lastName: string                 // Soyad
  tarih: string                    // YYYY-MM-DD
  kasaTutar: number                // Kasa Tutar
  kasaTutarCurrency: string        // Para Birimi (TL vb.)
  cariTutar: number                // Cari Tutar
  cariTutarCurrency: string        // Para Birimi

  // Sağ blok
  receiptNo: string                // Makbuz Numarası
  kasaKodu: string                 // Kasa Kodu (select)
  kasaKur: number                  // Kasa Kur
  cariKur: number                  // Cari Kur
  islemSube: string                // İşlem Şube (select)
  islemiYapan: string              // İşlemi Yapan
  aciklama: string                 // Açıklama

  // Eski kullanım için (tabloyu bozmasın)
  email?: string
}

export const initialCashRegister: ICashRegisterModel = {
  id: undefined,
  createdAt: undefined,
  updatedAt: undefined,

  cariAra: '',
  name: '',
  lastName: '',
  tarih: new Date().toISOString().slice(0, 10),

  kasaTutar: 0,
  kasaTutarCurrency: 'TL',
  cariTutar: 0,
  cariTutarCurrency: 'TL',

  receiptNo: '',
  kasaKodu: 'MERKEZ',
  kasaKur: 1,
  cariKur: 1,
  islemSube: 'ANKARA_CANKAYA',
  islemiYapan: '',
  aciklama: '',

  email: '',
}

export const cashRegisterValidation = Yup.object().shape({
  name: Yup.string().required('Ad zorunludur').min(2).max(50),
  lastName: Yup.string().required('Soyad zorunludur').min(2).max(50),
  tarih: Yup.string().required('Tarih zorunludur'),

  kasaTutar: Yup.number().typeError('Kasa tutar numerik olmalı').min(0).required(),
  kasaTutarCurrency: Yup.string().required('Para birimi zorunludur'),
  cariTutar: Yup.number().typeError('Cari tutar numerik olmalı').min(0).required(),
  cariTutarCurrency: Yup.string().required('Para birimi zorunludur'),

  receiptNo: Yup.string().max(50),
  kasaKodu: Yup.string().required('Kasa kodu zorunludur'),
  kasaKur: Yup.number().typeError('Kasa kur numerik olmalı').min(0).required(),
  cariKur: Yup.number().typeError('Cari kur numerik olmalı').min(0).required(),
  islemSube: Yup.string().required('İşlem şube zorunludur'),
  islemiYapan: Yup.string().max(100),
  aciklama: Yup.string().max(1000),

  email: Yup.string().email('Geçerli bir email giriniz').optional(),
})
